import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { registerDestructor } from '@ember/destroyable';
import tippy from 'tippy.js';

export default class PlaybackSpeedComponent extends Component {
  @service stereo;

  speeds = [0.8, 1.0, 1.25, 1.5, 1.75, 2.0];

  constructor() {
    super(...arguments);
    registerDestructor(this, () => {
      this.speedTooltip?.destroy();
      this.speedMenu?.destroy();
    });
  }

  get speed() {
    return this.stereo.playbackSpeed ?? 1;
  }

  get speedLabel() {
    return `${this.speed}×`;
  }

  // Tippy adopts the rendered menu element as its content, so Glimmer keeps updating it in place.
  @action
  setupSpeedMenu(element) {
    this.speedTooltip = tippy(element, {
      content: 'Playback speed',
      trigger: 'mouseenter focus',
      touch: false,
      interactive: true,
      placement: 'bottom',
      appendTo: 'parent',
      onShow: () => !this.speedMenu?.state.isVisible,
    });
    this.speedMenu = tippy(element, {
      content: element.nextElementSibling,
      interactive: true,
      trigger: 'click',
      placement: 'right',
      arrow: false,
      theme: 'menu',
      appendTo: () => element.closest('.dubbletrack-system') ?? document.body,
      offset: ({ reference }) => [0, this.offsetToOverlayNormalSpeed(reference)],
      onShow: () => this.speedTooltip?.hide(),
    });
  }

  // The row always opens with 1x over the button, so a second tap lands on it and resets.
  offsetToOverlayNormalSpeed(reference) {
    let popper = this.speedMenu?.popper;
    let normal = popper?.querySelector('[data-speed="1"]');
    if (!normal) {
      return 0;
    }
    let normalRect = normal.getBoundingClientRect();
    let normalCenter = normalRect.left - popper.getBoundingClientRect().left + normalRect.width / 2;
    return -(normalCenter + reference.width / 2);
  }

  @action
  setPlaybackSpeed(speed) {
    this.stereo.playbackSpeed = speed;
    this.speedMenu?.hide();
  }
}
